import axios from 'axios';
import { signOut } from 'next-auth/react';

import { logger } from '@dist-marketplace-frontend/services';

import { API } from '../helpers/pages';

export const keycloakLogout = async (callbackUrl?: string) => {
  try {
    await axios.get('/api/auth/keycloak_signout');
    await signOut(callbackUrl ? { callbackUrl } : { redirect: false });
  } catch (error) {
    logger.error({
      message: 'Unable to signout',
      error,
      route: API.KEYCLOAK_SIGNOUT,
    });
  }
};
